import React from "react";
import { Modal} from "antd";
import { URL_POND, URL_SKIM, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString, dateToHumanString } from "../../frameworks/Util";
import _ from "lodash";
import { SKIM_STOCK_ACTION_TH } from "../../constants/string";

export default function StockSkimHistoryModal(props) {
  const { open, onClose, target } = props;
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วันที่',
      dataIndex: 'created',
      key: 'created',      
      render: (value) => <center>{dateToHumanString(value)}</center>
    },

    {
      title: 'สินค้า',
      dataIndex: 'product_name',
      key: 'product_name',    
    },
    {
      title: 'ชื่อย่อสินค้า',
      dataIndex: 'product_short_name',
      key: 'product_short_name',    
    },
    {
      title: 'การแก้ไข',
      dataIndex: 'type',
      key: 'type',    
      render: (value) => <center>{SKIM_STOCK_ACTION_TH[value]}</center>
    },
    {
      title: 'จำนวน',
      dataIndex: 'amount',
      key: 'amount',    
      render: (value) => <center>{value}</center>  
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  return(
    <Modal
      title={<center>ประวัติสต๊อกสกิม</center>}
      open={open}
      onCancel={onClose}
      width={550}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      {target && <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_SKIM.SKIM_STOCK_LOG}
        hidePagination={true}
        params={{stock : target ? target.id : ''}}
      />}
    </Modal>
  )
}